import { render, staticRenderFns } from "./stockadjustment.vue?vue&type=template&id=04ccbced&scoped=true&"
import script from "./stockadjustment.vue?vue&type=script&lang=js&"
export * from "./stockadjustment.vue?vue&type=script&lang=js&"
import style0 from "./stockadjustment.vue?vue&type=style&index=0&id=04ccbced&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ccbced",
  null
  
)

export default component.exports